import { setRegisteredData } from "./registered-data";

$('.application-form').on('submit-success', function(event, data) {
    $('#modal-form-application').modal('hide');
    $('#answer').val('');
    setRegisteredData(data, '#modal-application-thanks');

    $('#modal-application-thanks').modal('show');

    if (typeof dataLayer !== 'undefined') {
        $('body').append('' +
            '<!--' +
            'Event snippet for 2025.07_Mlekpol_Maslanka_ClickButton_Wyślij_konkurs on https://maslankamragowska.pl/konkurs/: Please do not remove.' +
            'Place this snippet on pages with events you’re tracking.' +
            'Creation date: 07/07/2025' +
            '-->' +
            '<script>' +
            '  gtag(\'event\', \'conversion\', {' +
            '    \'allow_custom_scripts\': true,' +
            '    \'send_to\': \'DC-11229695/click0/2025000+standard\'' +
            '  });' +
            '</script>' +
            '<noscript>' +
            '<img src="https://ad.doubleclick.net/ddm/activity/src=11229695;type=click0;cat=2025000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>' +
            '</noscript>' +
            '<!-- End of event snippet: Please do not remove -->' +
            '');

        fbq('track', 'wyślij');

        if ($('main').data('source') === 'mailing') {
            $('body').append('<script type="text/javascript" src="https://system3secure.pl/p.ashx?o=398&e=538&f=js&t=#tid#"></script>');
        }
    }
});

$('.game-run').on('click', function() {
    // page swap
    $('section#application .page').addClass('d-none');
    $('section#application .page-result').removeClass('d-none').css('display', 'block');

    // modal (uncomment if you need a modal instead of page swap)
    //$('#modal-form-application').modal('show');
});

$('.result-try-again').on('click', function() {
    $('section#application .page').addClass('d-none');
    $('section#application .page-form').removeClass('d-none');
});

$('[name="personal_data[billType]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');

$('[name="personal_data[billTypeInfo]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).prop('disabled', $(this).is(':checked'));
    $('[name="personal_data[billPos]"]').closest('.form-group').prop('disabled', $(this).is(':checked'));

    $('[name="personal_data[billType]"]').val($(this).is(':checked') ? 'Faktura' : 'Paragon');
}).trigger('change');
